export default class MeetingRoomScene
{
    constructor(options = {})
    {
        this.id = options.id;
        this.background = options.background;
        this.foreground = options.foreground;
    }
}